import axios from "axios"
import { LOGIN_URL } from "../ApiConfigs"



export const postLoginApi = async(userDetails)=>{
    const response = await axios.post(LOGIN_URL,userDetails);
    return response.data
}